import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { getCityDetail, updateCity } from "../actions";
import { useParams } from "react-router-dom";
import DetailCard from "../../../components/siteDetailCard";
import Spinner from "../../../components/spinner";
import CityImageUpload from "../../../components/cityImageUpload";
import { uploadFileToS3, uploadSiteImage } from "../../sites/action";
import ProperSpinner from "../../../components/spinner/ProperSpinner";

const CityUpdate = () => {
  const { cityId } = useParams();
  const dispatch = useDispatch();
  const [city, setCity] = useState({});
  const [loading, setLoading] = useState(false);
  const [btnFlag, setBtnFlag] = useState(true);
  const [file, setFile] = useState();
  const [initialLoader, setInitialLoader] = useState(false);
  const [imageUrl, setImageUrl] = useState("");
  const fileHandler = (data) => {
    setBtnFlag(false);
    setFile(data);
  };
  const imageUrlHandler = (data) => {
    setImageUrl(data);
  };
  const getImageCrediantial = () => {
    setBtnFlag((prev) => !prev);
    setLoading(true);
    dispatch(
      uploadSiteImage(
        {
          folderType: 4,
          files: [file.name],
        },
        (response) => {
          if (!response.isSuccess) {
            setLoading(false);
          } else uploadFileToS3Hanlder(response.data);
        }
      )
    );
  };

  const uploadFileToS3Hanlder = async (fileResponses) => {
    dispatch(
      uploadFileToS3(file, fileResponses[0], (response) => {
        if (response.isSuccess) {
          setImageUrl((prev) => response.imageUrl);
          updateCityHandler(response.imageUrl);
        } else {
          setLoading(false);
        }
      })
    );
  };
  const updateCityHandler = (cityImage) => {
    const payload = { cityImage: cityImage };
    dispatch(
      updateCity(cityId, payload, () => {
        dispatch(
          getCityDetail(cityId, (res) => {
            if (res) {
              setCity(res);
              setImageUrl(res?.cityImage);
            }
            setLoading(false);
          })
        );
      })
    );
  };

  useEffect(() => {
    setInitialLoader(true);
    dispatch(
      getCityDetail(cityId, (res) => {
        setCity(res);
        setImageUrl(res?.cityImage);
        setInitialLoader(false);
      })
    );
  }, []);

  if (initialLoader) {
    return <ProperSpinner />;
  }
  console.log("city detail :", city);
  return (
    <div className="site-det-wrapper">
      {loading && <ProperSpinner />}
      <div className="site-det-header-container">
        <h3 className="w-50 mb-0 text-primary">{"City Update"}</h3>
      </div>
      <div className="site-content-container ">
        <div className="slider-container ">
          <CityImageUpload
            files={file}
            imageUrl={imageUrl}
            imageUrlHandler={imageUrlHandler}
            filesHandler={fileHandler}
          />
        </div>
        <div className="site-details-main-container">
          <div className="site-info-contaianer">
            <div className="site-details-container-2">
              <div className="personal-info-container">
                <h4 className="label-text heading text-underline ">
                  {"City Details"}
                </h4>
                <div className="site-data-container">
                  <DetailCard data={city.cityName} label={"city Name"} />
                  <DetailCard data={city.state} label={"State"} />
                  <DetailCard data={city.country} label={"Country"} />
                  <DetailCard data={city.pinCode} label={"Postal Code"} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="update-cities-btn-contianer">
        <button
          className="btn btn-primary user-details-btns"
          disabled={btnFlag}
          onClick={getImageCrediantial}
        >
          {"Save"}
        </button>
      </div>
    </div>
  );
};

export default CityUpdate;
